<template>
  <PageContainer type="bg2">
    <div class="carts">
      <template v-if="carts.length === 0">
        <div style="text-align: center;margin-top: 10px;font-size: 24px;">
          尚未加商品進入購物車
        </div>
      </template>
      <template v-else>
        <el-row v-for="cart in carts" :key="cart.item.id" class="cart" type="flex" align="middle">
          <el-col :xs="24" :md="14">
            <el-row :gutter="20">
              <el-col :span="2" :xs="3" class="cart__check-box">
                <el-checkbox :value="isCheck(cart.item.id)" @change="handleCheck(cart.item.id)" />
              </el-col>
              <el-row :gutter="20" type="flex" class="cart__info">
                <el-col :md="11" :xs="24" class="cart__image">
                  <router-link :to="{name: 'ProductDetail', params: { productId: cart.item.id }}">
                    <ImageContainer :image-src="cart.item.imageUrl" />
                  </router-link>
                </el-col>
                <el-col :md="11" :xs="24" class="cart__container">
                  <div class="cart__title">{{ cart.item.title }}</div>
                  <el-row type="flex" align="bottom" justify="space-between">
                    <div>
                      <div v-if="cart.item.originalPrice" class="cart__origin-price">${{ cart.item.originalPrice | currency }}</div>
                      <div class="cart__price">${{ cart.item.price | currency }}</div>
                    </div>
                    <div>
                      <div class="cart__num">庫存：{{ cart.item.stockNum | currency }}</div>
                      <div class="cart__num">購物回潤金：{{ cart.item.returnMoney || 0 }}</div>
                    </div>
                  </el-row>
                </el-col>
              </el-row>
            </el-row>
          </el-col>
          <el-col :xs="24" :md="10">
            <el-row type="flex" justify="space-between" align="middle">
              <el-input-number v-model="cart.num" size="small" :min="1" :max="cart.item.stockNum" @change="handleUpdate(cart)" />
              <span class="cart__price">${{ (cart.item.price * cart.num) | currency }}</span>
              <button @click="handleDelete(cart)">
                <img :src="DeleteImage">
              </button>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <el-row type="flex" justify="end" align="middle" class="cart__check-bar">
        <span>
          總額：
        </span>
        <div>
          ${{ total | currency }}
        </div>
        <el-button type="primary" :disabled="selectProduct.length === 0" @click="handleRedirectToPay">
          去結帳
        </el-button>
      </el-row>
      <el-row type="flex" justify="end" align="middle">
        <span>
          註:請在下單前勾選您想要購買的商品，然後點擊結帳
        </span>
      </el-row>
    </div>
  </PageContainer>
</template>
<script>
import PageContainer from '@/components/PageContainer'
import { mapGetters, mapActions } from 'vuex'
import ImageContainer from '@/components/ImageContainer'
import DeleteImage from '@/assets/img/address/del.png'

export default {
  components: {
    PageContainer,
    ImageContainer
  },
  data() {
    return {
      DeleteImage,
      selectProduct: []
    }
  },
  computed: {
    ...mapGetters(['carts']),
    isCheckAll() {
      return this.selectProduct.length === this.carts.length
    },
    total() {
      if (this.selectProduct.length === 0) {
        return 0
      } else {
        return this.carts.reduce((acc, cart) => {
          if (this.isCheck(cart.item.id)) {
            return acc + cart.item.price * cart.num
          }
          return acc
        }, 0)
      }
    }
  },
  mounted() {
    this.getCarts()
  },
  methods: {
    ...mapActions(['updateCart', 'deleteCart', 'setPayCarts', 'getCarts', 'setFromCart']),
    handleRedirectToPay() {
      this.setPayCarts(this.carts.filter(cart => this.isCheck(cart.item.id)))
      this.setFromCart(true)
      this.$router.push({ name: 'Pay' })
    },
    handleCheckAll() {
      if (this.isCheckAll) {
        this.selectProduct = []
      } else {
        this.selectProduct = this.carts.map(cart => cart.item.id)
      }
    },
    handleCheck(id) {
      if (this.isCheck(id)) {
        this.selectProduct = this.selectProduct.filter(item => item !== id)
      } else {
        this.selectProduct = [...this.selectProduct, id]
      }
    },
    isCheck(id) {
      return this.selectProduct.includes(id)
    },
    handleUpdate({ num, item }) {
      this.updateCart({ num, item })
    },
    async handleDelete({ num, item }) {
      const response = await this.deleteCart({ num, item })
      if (response) {
        this.$message({
          type: 'success',
          message: '刪除成功',
          duration: 1500
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.carts {
  width: 100%;
}
.cart {
  border-bottom: 1px solid $lightGrey;
  padding-bottom: 12px;
  flex-direction: column;
  @include minWidth992 {
    flex-direction: row;
  }
  & + .cart {
    padding-top: 12px;
  }
  &__info {
    flex-direction: column;
    position: relative;
    border: 1px solid $mainPurple;
    margin-bottom: 10px;
    background-color: #fff;
    @include minWidth992 {
      background-color: transparent;
      margin-bottom: 0px;
      border: 0px;
      flex-direction: row;
    }
  }
  &__image {
    border-bottom: 1px solid $mainPurple;
    @include minWidth992 {
      border: 0px;
    }
  }
  &__check-box {
    //position: absolute;
    //top: 10px;
    @include minWidth992 {
      top: 0;
      position: relative;
    }
  }
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &__title {
    color: $mainPurple;
    font-size: 24px;
  }
  &__origin-price {
    text-decoration:line-through;
    color:#929292;
    font-size: 14px;
    line-height: 24px;
  }
  &__price {
    color: red;
    font-size: 24px;
  }
  &__num {
    font-size: 14px;
  }
  &__check-bar {
    margin-top: 20px;
    gap: 20px;
  }
}

::v-deep.el-button--primary {
  background-color: $mainPurple;
  border: 0;
  &:hover, &:focus {
    background-color: $mainPurple;
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.7;
  }
}

::v-deep .el-checkbox__inner {
  width: 24px;
  height: 24px;
  &::after {
    height: 16px;
    left: 9px;
    width: 5px;
  }
  &:hover {
    border-color: $mainPurple;
  }
}
::v-deep.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: $mainPurple;
  border-color: $mainPurple;
}
button {
  background-color: transparent;
  border: 0;
  cursor: pointer;
}
</style>
